<div
  class="btn-skeleton loading"
  [style.height]="height"
  [style.width]="width"
  [ngStyle]="skeletonStyles"
  *ngIf="isLoading; else button"
></div>

<ng-template #button>
  <button
    [type]="typeButton"
    class="btn"
    [ngClass]="[TypeClassButton, color]"
    [disabled]="disabled"
    [style.height]="height"
    [style.width]="width"
    [style.font-size]="fontSize"
    [id]="idButton"
    (click)="onClickButton()"
  >
    <div
      class="btn-label"
      [class.reverse]="iconReverse"
      [style.fontWeight]="fontWeight"
    >
      <span
        [ngClass]="[color]"
        [style.fontSize]="fontSize"
        [class.disabled]="disabled"
      >
        <slot></slot>
      </span>
      <div [class.btn-icon]="icon" [class.btn-icon--left]="iconReverse">
        <slot name="icon" (slotchange)="slotChange($event)"></slot>
      </div>
    </div>
  </button>
</ng-template>
